export const keysConstants = {
  PARAMETER_SPEC: '$s3aRc#0ptM3d!@%',
  SECRET_KEY: '$pR0p3LrR2018@@%'
}
